import { Injectable, inject } from '@angular/core';
import { ProfileService } from '@modules/profile/services/profile.service';
import { IPermission } from '@modules/profile/interfaces/permission.interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionValidatorService {
  private readonly profileService: ProfileService = inject(ProfileService);

  constructor() { }

  public validateRolePermission(permissionStr: string): boolean{

    const permissions = this.profileService.permissions;

    if(this.profileService.isRoot || permissionStr == ''){
      return true;
    }

    const [module, action] = permissionStr.split(':');

    const permissionList = permissions[module] as string[];

    if(!permissionList){
      return false;
    }

    if(!action){
      return false;
    }

    const user_has_permission = permissionList.find((permission: string) => permission == action) !== undefined;

    return user_has_permission;
  }

  public async validateUserPassword(): Promise<boolean>
  {
    /*const resp = await Swal.fire({
      html: `Por favor ingrese su contraseña <b>${this.profileService.profile.Name}</b>`,
      input: "password",
      inputPlaceholder: "Ingresa tu contraseña",
      showCancelButton: true,
      confirmButtonColor: '#0B8',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Validar Contraseña'
    })

    if(resp.isConfirmed && resp.value !== ''){
      const url = `${this.service_path}/auth/validate-password`;
      this.loaderScreenService.show();

      return new Promise<boolean>((resolve, reject) => {
        this.httpClient.post(url, {password: resp.value})
        .subscribe(
          {
            next: (response:any) => {
              return resolve(true);
            },
            error: (err) => {
              console.error(err);
              Swal.fire('Error', err.message || 'Ocurrió un error al validar la contraseña', 'error');
              return resolve(false);
            }
          }
        )
        .add(() => {
          this.loaderScreenService.hide();
        });
      });
    }
    */
    return false;
  }

}
